import React from 'react';
import PropTypes from 'prop-types';
import { DarkScreenMask, PrimaryButton } from "@myplay/ui";

import { capitalize } from '../../utils/stringManipulations';
import { WHITE, GREEN_SUCCESS, RED } from '../../styles/colors';
import I18N from '../../I18N';

const ConfrimModal = ({ isVisible, name, onApprove, onDismiss }) => {

  return (
    <DarkScreenMask isVisible={isVisible}>
      <div className="single-coach__confirm-modal">
        <div className="single-coach__confirm-modal__title">
          <span>{`${capitalize(I18N.t("ASSGIN_OPERATOR_WARNING"))} ${name} ${I18N.t("OPERATOR")}?`}</span>
          <span>{I18N.t("IRREVERSIBLE_OPERATION_WARNING")}</span>
        </div>
        <div className="single-coach__confirm-modal__buttons">
          <PrimaryButton
            color={WHITE}
            background={GREEN_SUCCESS}
            onClick={onApprove}
            data-testid="change-acount-type-yes"
          >
            {I18N.t("YES").toUpperCase()}
          </PrimaryButton>
          <PrimaryButton
            color={WHITE}
            background={RED}
            onClick={onDismiss}
          >
            {I18N.t("NO").toUpperCase()}
          </PrimaryButton>
        </div>
      </div>
    </DarkScreenMask>
  );
};

ConfrimModal.propTypes = {
  isVisible: PropTypes.bool, 
  onApprove: PropTypes.func,
  onDismiss: PropTypes.func,
  name: PropTypes.string
};

ConfrimModal.defaultProps = {
  isVisible: false, 
  onApprove: ()=> {},
  onDismiss: ()=> {},
  name: ""
};

export default ConfrimModal;